import type { Ref } from "react";
import { useImperativeHandle, useRef } from "react";

import Button, { ButtonGroup } from "$src/core/components/atoms/Button/Button";
import Modal from "$src/core/components/atoms/Modal";
import type { ModalRef } from "$src/core/components/atoms/Modal/types";
import type { IconName } from "$src/core/models/icon";

type Action = {
  name: string;
  icon: IconName;
  title: string;
  onPress: () => void;
};

type Props = {
  ref?: Ref<ModalRef>;
  title: string;
  actions: Action[];
};

const ActionsModal = ({ ref: forwardedRef, title, actions }: Props) => {
  const ref = useRef<ModalRef | null>(null);

  useImperativeHandle(
    forwardedRef,
    () => ({
      present: () => ref.current?.present(),
      dismiss: () => ref.current?.dismiss(),
    }),
    [ref],
  );

  const handleAction = (action: Action) => {
    action.onPress();
    ref.current?.dismiss();
  };

  return (
    <Modal ref={ref} title={title}>
      <ButtonGroup>
        {actions.map((action) => (
          <Button
            key={action.title}
            name={action.name}
            icon={action.icon}
            preset="secondary"
            label={action.title}
            onPress={() => handleAction(action)}
          />
        ))}
      </ButtonGroup>
    </Modal>
  );
};

export default ActionsModal;
